"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMXContentAnchor = exports.AlertNote = exports.ChoiceSelect = exports.FloatRight = exports.ProjectBox = exports.DomainItemBox = exports.Icon = exports.Icons = exports.ExpandingTextArea = exports.EditableText = exports.Header = exports.Clearfix = void 0;
var React = require("react");
var buttons_1 = require("./buttons");
var columns_1 = require("./columns");
var typestyle_1 = require("typestyle");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var config_1 = require("../config");
function Clearfix(props) {
    return React.createElement("div", { className: "Clearfix" });
}
exports.Clearfix = Clearfix;
function Header(props) {
    return (React.createElement("div", { className: "Header" },
        React.createElement("h4", null, props.text)));
}
exports.Header = Header;
var EditableText = (function (_super) {
    __extends(EditableText, _super);
    function EditableText(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.value,
            editing: false,
        };
        return _this;
    }
    EditableText.prototype.handleFormEvent = function (event) {
        var target = event.target;
        var value = target.type === "checkbox" ? target.checked : target.value;
        var name = target.name;
        var newState = {};
        newState[name] = value;
        this.setState(newState);
    };
    EditableText.prototype.activate = function () {
        this.setState({ editing: true });
    };
    EditableText.prototype.deactivate = function () {
        this.setState({ editing: false });
    };
    EditableText.prototype.componentDidUpdate = function () {
        var state = this.state;
        if (state.editing) {
            this.textarea.focus();
        }
    };
    EditableText.prototype.onSubmit = function () {
        return this.props.onSubmit(this.state.value);
    };
    EditableText.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var state = this.state;
        var editingModifier = state.editing ? "EditableText--editing" : "";
        var showButton = state.value !== props.value;
        return (React.createElement("div", null,
            React.createElement("textarea", { className: (0, typestyle_1.classes)("EditableText", "form-control", editingModifier), name: "value", onChange: this.handleFormEvent.bind(this), onBlur: this.deactivate.bind(this), value: state.value, ref: function (element) {
                    _this.textarea = element;
                } }),
            showButton && (React.createElement(columns_1.RightAlign, null,
                React.createElement(buttons_1.PrimaryButton, { onClick: this.onSubmit.bind(this), children: gettext("Save") })))));
    };
    return EditableText;
}(React.Component));
exports.EditableText = EditableText;
var ExpandingTextArea = (function (_super) {
    __extends(ExpandingTextArea, _super);
    function ExpandingTextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            focused: false,
            text: props.value,
        };
        return _this;
    }
    ExpandingTextArea.prototype.onFocus = function (focused) {
        this.setState({ focused: focused });
    };
    ExpandingTextArea.prototype.onSubmit = function () {
        var props = this.props;
        props.onSubmit(this.state.text);
        var clear = props.clearOnSubmit;
        if (clear === undefined ? true : clear) {
            this.setState({ text: "" });
        }
    };
    ExpandingTextArea.prototype.handleFormEvent = function (event) {
        this.props.onChange();
        var target = event.target;
        var value = target.type === "checkbox" ? target.checked : target.value;
        var name = target.name;
        var newState = {};
        newState[name] = value;
        this.setState(newState);
    };
    ExpandingTextArea.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var state = this.state;
        var changed = props.value !== state.text;
        var changedModifier = changed ? "ExpandingTextArea--changed" : "";
        return (React.createElement("div", null,
            React.createElement("textarea", { className: (0, typestyle_1.classes)("form-control", "ExpandingTextArea", changedModifier), name: "text", value: state.text, placeholder: props.placeholder, onFocus: function () { return _this.onFocus(true); }, onBlur: function () { return _this.onFocus(false); }, onChange: this.handleFormEvent.bind(this) }),
            (state.focused || changed) && (React.createElement(columns_1.RightAlign, null,
                React.createElement(buttons_1.PrimaryButton, { onClick: this.onSubmit.bind(this), className: "mt-2" }, props.submitButtonText || "Save")))));
    };
    return ExpandingTextArea;
}(React.Component));
exports.ExpandingTextArea = ExpandingTextArea;
var Icons = (function () {
    function Icons() {
    }
    Icons.angle_down = "angle-down";
    Icons.angle_right = "angle-right";
    Icons.arrow_circle_right = "arrow-alt-circle-right";
    Icons.arrow_up = "arrow-up";
    Icons.arrow_down = "arrow-down";
    Icons.building = "building";
    Icons.calendar = "calendar";
    Icons.caret_down = "caret-down";
    Icons.check = "check";
    Icons.check_circle = "check-circle";
    Icons.circle = "circle";
    Icons.close_circle = "times-circle";
    Icons.cog = "cog";
    Icons.copy = "copy";
    Icons.delete = "trash-alt";
    Icons.download = 'download';
    Icons.edit = "edit";
    Icons.file_code = "file-code";
    Icons.file_excel = "file-excel";
    Icons.file_export = "file-export";
    Icons.filter = "filter";
    Icons.grip_v_and_h = "arrows-alt";
    Icons.grip_vertical = "arrows-alt-v";
    Icons.phone = "phone";
    Icons.phone_square = "phone-square";
    Icons.plus_circle = "plus-circle";
    Icons.sort_ascending = "sort-up";
    Icons.sort_descending = "sort-down";
    Icons.sorting = "sort-amount-down";
    Icons.sync = "sync";
    Icons.trash = "trash-alt";
    Icons.unlink = "unlink";
    Icons.asterisk = "asterisk";
    Icons.tag = "tag";
    Icons.exclamation = "exclamation-circle";
    Icons.calendar_day = "calendar-day";
    Icons.map_with_locations = "map-marked-alt";
    Icons.map_marker = "map-marker";
    Icons.map_layer = "layer-group";
    Icons.user_add = "user-plus";
    Icons.star = "star";
    Icons.logout = "sign-out-alt";
    Icons.save = "save";
    return Icons;
}());
exports.Icons = Icons;
function Icon(props) {
    var floatLeftModifier = props.floatLeft ? "Icon--floatleft" : "";
    var iconPrefix = props.prefix || "fas";
    return (React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: [iconPrefix, props.name], className: (0, typestyle_1.classes)(floatLeftModifier, props.className), size: props.size, transform: props.transform, fixedWidth: !!props.fixedWidth, color: props.color }));
}
exports.Icon = Icon;
function DomainItemBox(props) {
    var typeModifier = "";
    if (props.type === 1) {
        typeModifier = "DomainItemBox--risk";
    }
    else if (props.type === 2) {
        typeModifier = "DomainItemBox--control";
    }
    else if (props.type === 3) {
        typeModifier = "DomainItemBox--action";
    }
    return (React.createElement("span", null,
        React.createElement("span", { className: (0, typestyle_1.classes)("DomainItemBox", typeModifier) }, props.value),
        "\u00A0"));
}
exports.DomainItemBox = DomainItemBox;
function ProjectBox(props) {
    return (React.createElement("span", null,
        React.createElement("span", { className: "DomainItemBox DomainItemBox--project" }, props.value),
        "\u00A0"));
}
exports.ProjectBox = ProjectBox;
function FloatRight(props) {
    return React.createElement("div", { className: (0, typestyle_1.classes)("FloatRight", props.className) }, props.children);
}
exports.FloatRight = FloatRight;
var ChoiceSelect = function (props) {
    var multiple = props.multiple !== undefined;
    var options = (0, config_1.groupBy)(props.choices, function (c) { return c.group_name || ""; }).map(function (group, groupIndex) {
        if (group.key) {
            return (React.createElement("optgroup", { label: group.key, key: groupIndex }, group.members.map(function (choice, choiceIndex) { return (React.createElement("option", { key: choiceIndex, value: choice.value, className: choice.htmlClass }, choice.display_name)); })));
        }
        else {
            return (React.createElement(React.Fragment, null, group.members.map(function (choice, index) {
                if (choice.display_name != undefined) {
                    return (React.createElement("option", { key: "".concat(groupIndex, "-").concat(index), value: choice.value, className: choice.htmlClass }, choice.display_name));
                }
                else {
                    var regularChoice = choice;
                    return (React.createElement("option", { key: "".concat(groupIndex, "-").concat(index), value: regularChoice[0] }, regularChoice[1]));
                }
            })));
        }
    });
    return (React.createElement("select", { className: props.className || "form-control", id: props.id, name: props.name, value: props.value, onChange: props.onChange, ref: function (me) { return props.autofocus && me && me.focus(); }, onFocus: props.onFocus, onBlur: props.onBlur, tabIndex: props.tabIndex, multiple: multiple }, options));
};
exports.ChoiceSelect = ChoiceSelect;
var AlertNote = function (props) {
    return (React.createElement("div", { className: "alert alert-info w-100", role: "alert" }, props.children));
};
exports.AlertNote = AlertNote;
var HTMXContentAnchor = (function (_super) {
    __extends(HTMXContentAnchor, _super);
    function HTMXContentAnchor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HTMXContentAnchor.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return false;
    };
    HTMXContentAnchor.prototype.componentDidMount = function () {
        htmx.process(this.ref);
    };
    HTMXContentAnchor.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { ref: function (ref) { _this.ref = ref; }, className: "ExternalContentAnchor" }, this.props.children);
    };
    return HTMXContentAnchor;
}(React.Component));
exports.HTMXContentAnchor = HTMXContentAnchor;
